module.exports = __webpack_public_path__ + "static/media/black_member_banner.0040bf63.webp";